import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=462d3909&"
import script from "./Iframe.vue?vue&type=script&lang=js&"
export * from "./Iframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462d3909')) {
      api.createRecord('462d3909', component.options)
    } else {
      api.reload('462d3909', component.options)
    }
    module.hot.accept("./Iframe.vue?vue&type=template&id=462d3909&", function () {
      api.rerender('462d3909', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Iframe.vue"
export default component.exports